/** LookupEnums (LE) must align with their associated Lookups. The associated Lookups must be marked as immutable.
 * Name the enum for the LookupGroup's Code. Name the keys to align with the Lookup's Code. The values should align with the Lookup's Murn.
 */
export namespace LE {
  export enum DocumentCategory {
    Site = "murn:iheer2:lookup/DocumentCategory/Site",
    Facility = "murn:iheer2:lookup/DocumentCategory/Facility",
    Incident = "murn:iheer2:lookup/DocumentCategory/Incident",
    Inquiry = 'murn:iheer2:lookup/DocumentCategory/Inquiry'
  }

  export enum State {
    AK = "murn:iheer2:lookup/State/AK",
    AL = "murn:iheer2:lookup/State/AL",
    AR = "murn:iheer2:lookup/State/AR",
    AS = "murn:iheer2:lookup/State/AS",
    AZ = "murn:iheer2:lookup/State/AZ",
    CA = "murn:iheer2:lookup/State/CA",
    CO = "murn:iheer2:lookup/State/CO",
    CT = "murn:iheer2:lookup/State/CT",
    DC = "murn:iheer2:lookup/State/DC",
    DE = "murn:iheer2:lookup/State/DE",
    FL = "murn:iheer2:lookup/State/FL",
    GA = "murn:iheer2:lookup/State/GA",
    GU = "murn:iheer2:lookup/State/GU",
    HI = "murn:iheer2:lookup/State/HI",
    IA = "murn:iheer2:lookup/State/IA",
    ID = "murn:iheer2:lookup/State/ID",
    IL = "murn:iheer2:lookup/State/IL",
    IN = "murn:iheer2:lookup/State/IN",
    KS = "murn:iheer2:lookup/State/KS",
    KY = "murn:iheer2:lookup/State/KY",
    LA = "murn:iheer2:lookup/State/LA",
    MA = "murn:iheer2:lookup/State/MA",
    MD = "murn:iheer2:lookup/State/MD",
    ME = "murn:iheer2:lookup/State/ME",
    MI = "murn:iheer2:lookup/State/MI",
    MN = "murn:iheer2:lookup/State/MN",
    MO = "murn:iheer2:lookup/State/MO",
    MP = "murn:iheer2:lookup/State/MP",
    MS = "murn:iheer2:lookup/State/MS",
    MT = "murn:iheer2:lookup/State/MT",
    NC = "murn:iheer2:lookup/State/NC",
    ND = "murn:iheer2:lookup/State/ND",
    NE = "murn:iheer2:lookup/State/NE",
    NH = "murn:iheer2:lookup/State/NH",
    NJ = "murn:iheer2:lookup/State/NJ",
    NM = "murn:iheer2:lookup/State/NM",
    NV = "murn:iheer2:lookup/State/NV",
    NY = "murn:iheer2:lookup/State/NY",
    OH = "murn:iheer2:lookup/State/OH",
    OK = "murn:iheer2:lookup/State/OK",
    OR = "murn:iheer2:lookup/State/OR",
    PA = "murn:iheer2:lookup/State/PA",
    PR = "murn:iheer2:lookup/State/PR",
    RI = "murn:iheer2:lookup/State/RI",
    SC = "murn:iheer2:lookup/State/SC",
    SD = "murn:iheer2:lookup/State/SD",
    TN = "murn:iheer2:lookup/State/TN",
    TX = "murn:iheer2:lookup/State/TX",
    UT = "murn:iheer2:lookup/State/UT",
    VT = "murn:iheer2:lookup/State/VT",
    VA = "murn:iheer2:lookup/State/VA",
    VI = "murn:iheer2:lookup/State/VI",
    WA = "murn:iheer2:lookup/State/WA",
    WI = "murn:iheer2:lookup/State/WI",
    WV = "murn:iheer2:lookup/State/WV",
    WY = "murn:iheer2:lookup/State/WY",
    AB = "murn:iheer2:lookup/State/AB",
    BC = "murn:iheer2:lookup/State/BC",
    MB = "murn:iheer2:lookup/State/MB",
    NB = "murn:iheer2:lookup/State/NB",
    NL = "murn:iheer2:lookup/State/NL",
    NS = "murn:iheer2:lookup/State/NS",
    ON = "murn:iheer2:lookup/State/ON",
    PE = "murn:iheer2:lookup/State/PE",
    QC = "murn:iheer2:lookup/State/QC",
    SK = "murn:iheer2:lookup/State/SK",
  }
  export enum SiteStatus {
    Assessment = "murn:iheer2:lookup/SiteStatus/Assessment",
    Consultation = "murn:iheer2:lookup/SiteStatus/Consultation",
    Discovery = "murn:iheer2:lookup/SiteStatus/Discovery",
    FurtherAssessmentNeeded = "murn:iheer2:lookup/SiteStatus/FurtherAssessmentNeeded",
    NFA = "murn:iheer2:lookup/SiteStatus/NFA",
    NFAIC = "murn:iheer2:lookup/SiteStatus/NFAIC",
    NFAISST = "murn:iheer2:lookup/SiteStatus/NFAISST",
    NFATU = "murn:iheer2:lookup/SiteStatus/NFATU",
    NFAU = "murn:iheer2:lookup/SiteStatus/NFAU",
    Referred = "murn:iheer2:lookup/SiteStatus/Referred",
    RemedyImplemented = "murn:iheer2:lookup/SiteStatus/RemedyImplemented",
    RemedyNeeded = "murn:iheer2:lookup/SiteStatus/RemedyNeeded",
    RemedySelected = "murn:iheer2:lookup/SiteStatus/RemedySelected",
    Unreviewed = "murn:iheer2:lookup/SiteStatus/Unreviewed",
  }
  export enum SitePriority {
    High = "murn:iheer2:lookup/SitePriority/High",
    Unranked = "murn:iheer2:lookup/SitePriority/Unranked",
    None = "murn:iheer2:lookup/SitePriority/None",
    Low = "murn:iheer2:lookup/SitePriority/Low",
    Medium = "murn:iheer2:lookup/SitePriority/Medium",
  }
  export enum Program {
    PaSi = "murn:iheer2:lookup/SiteProgram/PaSi",
  }
  export enum IncidentStatus {
    Open = "murn:iheer2:lookup/IncidentStatus/Open",
  }

  export enum InquiryStatus {
    Open = "murn:iheer2:lookup/InquiryStatus/Open",
    Closed = "murn:iheer2:lookup/InquiryStatus/Closed",
  }

  export enum SubstanceCategory {
    GroupCode = "murn:ust:lookup/SubstanceCategory",
    Chemical = "murn:iheer2:lookup/SubstanceCategory/CHEM",
    Oil = "murn:iheer2:lookup/SubstanceCategory/OIL",
    Pollutant = "murn:iheer2:lookup/SubstanceCategory/POCO",
    Unlisted = "murn:iheer2:lookup/SubstanceCategory/UNKN",
  }

  export enum IncidentSubstanceUnit {
    Gallons = "murn:iheer2:lookup/IncidentSubstanceUnit/Gallons",
    Barrels = "murn:iheer2:lookup/IncidentSubstanceUnit/Barrels"
  }
}
